import classes from "./Research.module.scss";
import BoldTitle from '../../../Titles/BoldTitle/BoldTitle';
import CirclePink from "../../../CirclePink/CirclePink";
import Image from '../../../Image/Image';

import seoCore from "../../../Assets/Img/Src/Research/seoCore.png"
import seoCoreWebp from "../../../Assets/Img/Webp/seoCore.webp"

import analys from "../../../Assets/Img/Src/Research/analys.png"
import analysWebp from "../../../Assets/Img/Webp/analys.webp"

const Research = () => {
  return (
    <div className={classes.Research}>
      <CirclePink customClass={classes.Circle} />
      <div className={classes.Wrap}>
        <BoldTitle
          text={<>Поняв проблемы с индексацией сайта, мы<span> перешли к исследованию запросов</span>, находящихся в ТОПе поисковых систем</>}
          customClass={classes.Title}
        />
        <div className={classes.Block}>
          <div className={classes.Item}>
            <span className={classes.Number}>01.</span>
            <p className={classes.Description}>
              <b>Для того чтобы понять,</b><br />
          как позиции поисковых запросов связаны с трафиком, необходимо было проверить по каким запросам и на каких позициях находится сайт.
          </p>
          </div>
          <div className={classes.Item}>
            <span className={classes.Number}>02.</span>
            <p className={classes.Description}>
              <b>Для решения этой задачи</b><br />
            мы создали семантическое ядро, состоящее из 20 000 запросов, определив  позиции каждого. Таким образом, сразу стало ясно: над какими пулами запросов необходимо активно работать, а какие уже приносят трафик.
          </p>
          </div>
        </div>
      </div>
      <div className={classes.Body}>
        <div className={classes.ImgWrap}>
            <Image src={seoCore} srcWebp={seoCoreWebp} />
       </div>
      </div>
      <div className={classes.Wrap + " " + classes.SecondWrap}>
        <div className={classes.WrapTitle}>
          <BoldTitle
            text={<>Но сложно было сформулировать цели, не зная данных по динамике и показателям основных конкурентов</>}
            customClass={classes.SecondTitle}
          />
        </div>
        <div className={classes.Block}>
          <div className={classes.Item + " " + classes.SecondItem}>
            <span className={classes.Number}>01.</span>
            <p className={classes.Description}>
            Совместно с Заказчиком были определены основные конкуренты.
            </p>
            <span className={classes.Number}>02.</span>
            <p className={classes.Description}>
              По данным сайтам была собрана вся возможная статистика.
          </p>
          </div>
          <div className={classes.Item + " " + classes.SecondItem}>
            <span className={classes.Number}>03.</span>
            <p className={classes.Description}>
            Кроме этого был проведён экспертный анализ сайтов конкурентов для выявления маркетинговых ходов и предложений, а также полезных технических «фишек», которые можно было бы реализовать на сайте.
          </p>
          </div>
        </div>
     
      </div>
        <div className={classes.Body}>
          <div className={classes.ImgWrap}>

              <Image src={analys} srcWebp={analysWebp} />
            </div>
        </div>
    </div>
  )
}


export default Research;